export default "__VITE_ASSET__PW1eUPjQ__"